import requestv2 from "~/utils/http-v2";

const employeeEvaluationApi = {
	gets : async (params) => {
		const url = 'v2/evaluation';
		return await requestv2.get(url, {params});
	},
	getCycle : async (id) => {
		const url = `v2/evaluation/cycle/${id}`;
		return await requestv2.get(url);
	},
	reEvaluate : async (id) => {
		const url = `v2/evaluation/re-evaluate/${id}`;
		return await requestv2.post(url);
	},
	setCycle : async (params) => {
		const url = `v2/evaluation/set-cycle/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default employeeEvaluationApi;
